import { FC, ReactElement, useRef } from 'react';

import { Picture } from '../../components';
import { Image, ImageFormatSize } from '../../entities/Media/Media';
import { useTrans } from '../../hooks';
import { Button, Dialog, DialogContent } from '..';

import './PictureTheatre.scss';

interface PictureTheatreProps extends Image {
    formatOverride?: ImageFormatSize;
    className?: string;
}

export const PictureTheatre: FC<PictureTheatreProps> = ({
    formatOverride,
    className = '',
    ...imageProps
}): ReactElement => {
    const trans = useTrans();

    const dialogRef = useRef<HTMLDialogElement>(null);
    const pictureRef = useRef<HTMLVideoElement>(null);

    const handleOpenDialog = async (): Promise<void> => {
        if (!dialogRef.current) {
            return;
        }

        dialogRef.current.showModal();
    };

    const handleCloseDialog = async (): Promise<void> => {
        if (!dialogRef.current) {
            return;
        }

        dialogRef.current.close();
    };

    return (
        <div className={`picture-theatre ${className}`}>
            <Button
                text={trans('compositions.pictureTheatre.enlarge')}
                onClick={handleOpenDialog}
                className="picture-theatre__poster-button"
                labelClassName="picture-theatre__poster-image-wrapper"
            >
                <Picture
                    {...imageProps}
                    formatOverride={formatOverride || ImageFormatSize.thumbnail}
                    className="picture-theatre__poster"
                    imageClassName="picture-theatre__poster-image"
                />
            </Button>

            <Dialog
                ref={dialogRef}
                hasLightBackdrop
                enableBackdropClose
                onClose={handleCloseDialog}
                className="picture-theatre__dialog"
                closeButtonClassName="picture-theatre__dialog-close-button"
            >
                <DialogContent
                    className="picture-theatre__dialog-content"
                    contentWrapperClassName="picture-theatre__dialog-content-wrapper"
                >
                    <Picture
                        {...imageProps}
                        ref={pictureRef}
                        loading="lazy"
                        formatOverride={ImageFormatSize.original}
                        className="picture-theatre__dialog-picture"
                        imageClassName="picture-theatre__dialog-image"
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};
